import React from 'react';
import { createStyles, makeStyles, Paper, Theme } from '@material-ui/core';

interface Props {
  heading?: string,
  children: React.ReactNode,
  isCredit?: boolean;
}

const useStyles = makeStyles<Theme, Props>((theme: Theme) =>
  createStyles({
    rounded: {
      borderRadius: '10px',
    },
    header: props => ({
      backgroundColor: props.isCredit ? '#990033' : '#00c1bd',
      padding: theme.spacing(2),
      color: '#fff',
      fontFamily: 'Moderat-Black',
      borderRadius: '10px 10px 0 0',
      fontSize: '1rem',
    }),
    content: {
      color: theme.palette.text.secondary,
      padding: theme.spacing(2)
    },
    footer: props => ({
      padding: theme.spacing(1),
      backgroundColor: props.isCredit ? '#740127' : '#008888',
      borderRadius: '0 0 10px 10px'
    }),
    '@media print': {
      header: {
        display: 'none'
      },
      footer: {
        display: 'none'
      }
    }
  })
);

const PaperColumn: React.FunctionComponent<Props> = (props) => {
    const classes = useStyles(props);
    return (
      <Paper className={classes.rounded}>
      <div className={classes.header}>
          {props.heading}
      </div>
      <div className={classes.content}>
          {props.children}
      </div>
      <div className={classes.footer}>
          &nbsp;
      </div>
  </Paper>
    )
}

export default PaperColumn;